export default __webpack_public_path__ + "static/media/total_users.91cac01b.svg";